/**
 * Copyright (c) 2017 Interacso
 * All rights reserved.
 */

import React from 'react';
import QRCode from 'qrcode.react';

import { Element, ElementProps } from '../Element';

interface ElementExtraProps {
  url: string;
}

interface ElementExtraState {
  url: string;
}

/**
 * Elemento de tipo QR Code
 */
export default class QrcodeElement extends Element<
  ElementExtraProps,
  ElementExtraState
> {
  constructor(props: ElementProps<ElementExtraProps>) {
    super(props);

    this.state = {
      url: props.element.url,
    };
  }

  componentWillReceiveProps(nextProps: ElementProps<ElementExtraProps>) {
    if (nextProps.element.url !== this.props.element.url) {
      this.setState({ url: nextProps.element.url });
    }
  }

  render() {
    return (
      <div>
        <QRCode
          value={this.state.url}
          size={this.getStyle().width}
          renderAs="svg"
          bgColor="transparent"
          fgColor={this.getStyle().color}
        />
      </div>
    );
  }
}
